import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, TextField, Typography } from "@mui/material";
import { formatCurrency } from "../../../../utils/formatter";
import { ClientProps } from "../../../client/QRCode";

interface RefundModalProps {
  showModal: boolean;
  setRefundModal: (value: boolean) => void;
  selected: ClientProps | undefined;
  loading: boolean;
  save: () => void;
}

const RefundConfirmationModal = ({
  showModal,
  setRefundModal,
  selected,
  loading,
  save,
}: RefundModalProps) => {

  return (
    <Dialog
      open={showModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h5" fontWeight="700" component="h1" textAlign="center">
          Devolução de Crédito
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Typography variant="body1" fontWeight="600" component="h3" textAlign="center">
            Confirme os dados com o Cliente antes de prosseguir
          </Typography>

          <Grid container spacing={2} sx={{ marginTop: 3 }}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Nome"
                variant="outlined"
                value={selected?.name}
                fullWidth
                disabled
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="E-mail"
                variant="outlined"
                value={selected?.email}
                fullWidth
                disabled
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Telefone"
                variant="outlined"
                value={selected?.phone}
                fullWidth
                disabled
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Valor a ser devolvido"
                value={formatCurrency(selected?.balance ?? 0)}
                fullWidth
                disabled
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          sx={{ marginBottom: 1 }}
          onClick={() => setRefundModal(false)}
          disabled={loading}
        >
          Fechar
        </Button>
        <Button
          variant="contained"
          sx={{ marginBottom: 1, marginRight: 2 }}
          onClick={() => save()}
        >
          Concluir
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RefundConfirmationModal;
